// App name: Custom Breadcum Link App
// Description: Single Product - Redirected to shop page with respective category parameter

const customBreadcumLinkApp = (function ($) {

  // variables
  let _breadcum = $('body.single-product .woocommerce-breadcrumb');

  // init
  function init() {
      _initReplaceLink();
  }

  function _initReplaceLink() {
    setTimeout(() => {

      if (_breadcum.length > 0) {
        let _item = _breadcum.find('a');

        _item.each(function(index) {

          if (index > 1) {
            // console.log(index);

            let _self   = $(this);
            let _arr    = _self.attr('href').split('/');
            let _length = _arr.length;

            _self.attr('href', `/shop/?category=${ _arr[Number(_length - 2)] }`)

            // console.log(_arr[Number(_length - 2)]);
          }
        })
      }

    }, 1000);

  }

  return {
      init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  customBreadcumLinkApp.init();
});
